import * as React from "react";
import { extractHashtagsWithIndices } from "components/draft-js-mention/utils/hashtag";
import ErrorIcon from "material-ui/svg-icons/alert/error";
import Tooltip from "@material-ui/core/Tooltip";
import theme from "styles/theme";
import { SeverityMessages } from "constants/product-collection";

interface IProps {
    column: any;
    colDef: any;
    node: any;
    rowIndex: number;
    value: string;
    onSearchChange: (e) => void;
    formatValue: (value: any) => string;
}

const alertColorBySeverity = {
    [SeverityMessages.Error]: theme.palette.error,
    [SeverityMessages.Warning]: theme.palette.warningAlertIconColor,
};

const styles = {
    tooltip: {
        fontSize: "11px",
    },
};

class DefaultRenderer extends React.PureComponent<IProps> {
    constructor(props) {
        super(props);
    }

    render() {
        const { colDef, formatValue, node, value, onSearchChange } = this.props;
        const { getAlertInfo } = colDef.cellRendererParams || {};
        const { hasAlertInfo, displayIcon = true, message, severity } = (getAlertInfo && getAlertInfo(value)) || {};

        let formattedValue = "";

        // TODO: find a prettier way to express this
        if (node.group && colDef.cellRenderer !== "agGroupCellRenderer") {
            if (node.level === 0) {
                if (node.aggData && colDef.aggFunc) {
                    formattedValue = formatValue(value);
                }
            } else {
                formattedValue = formatValue(value);
            }
        } else {
            formattedValue = formatValue(value);
        }

        const tags = extractHashtagsWithIndices(formattedValue);
        const parts = [];
        let cursor = 0;
        const alertColor = hasAlertInfo
            ? alertColorBySeverity[severity] || alertColorBySeverity[SeverityMessages.Warning]
            : null;

        if (tags.length) {
            tags.forEach(({ indices: [start, end] }, i) => {
                if (start !== 0) {
                    parts.push(<span key={`before-${i}`}>{formattedValue.slice(cursor, start)}</span>);
                }
                const tag = formattedValue.slice(start, end);
                parts.push(
                    <a href="#" onClick={onSearchChange} className="hashTag" data-search-text={tag} key={`tag-${i}`}>
                        {tag}
                    </a>
                );
                cursor = end;
            });
            if (cursor <= formattedValue.length) {
                parts.push(<span key="end">{formattedValue.slice(cursor)}</span>);
            }
        } else if (hasAlertInfo) {
            parts.push(
                <span key="0" style={{ display: "flex", justifyContent: "space-between" }}>
                    <span style={!displayIcon ? { color: alertColor } : {}}>{formattedValue}</span>
                    {displayIcon && !!message && (
                        <Tooltip title={<div style={styles.tooltip}>{message}</div>} placement="top-start">
                            <ErrorIcon color={alertColor} />
                        </Tooltip>
                    )}
                </span>
            );
        } else {
            parts.push(<span key="0">{formattedValue}</span>);
        }

        return <React.Fragment>{parts}</React.Fragment>;
    }
}

// separate export statement so function name shows up in React DevTools
export { DefaultRenderer };
